import React from 'react';
import { FormattedMessage } from 'react-intl';
import { capitalizeFirstLetter } from 'src/utils/string';

/**
 * Traduz termos de variáveis de cálculo para o idioma configurado
 * Centraliza toda a lógica de tradução em um local
 */
export function translateVariableTerm(termo, resources, intl) {
  switch (termo) {
    case 'Meta':
      return capitalizeFirstLetter(resources.meta);
    case 'Realizado':
      return <FormattedMessage id="realizado" />;
    case 'Desempenho':
      return capitalizeFirstLetter(resources.desempenho);
    case 'MetaAcumulado':
      return capitalizeFirstLetter(resources.metaacumulado);
    case 'RealizadoAcumulado':
      return <FormattedMessage id="realizadoAcumulado" />;
    case 'DesempenhoAcumulado':
      return capitalizeFirstLetter(
        intl.formatMessage(
          { id: 'desempenhoAcumulado' },
          { desempenho: resources.desempenho }
        )
      );
    case 'MetaPeriodoAnterior':
      return capitalizeFirstLetter(
        intl.formatMessage(
          { id: 'label.metaPeriodoAnterior' },
          { meta: resources.meta }
        )
      );
    case 'RealizadoPeriodoAnterior':
      return <FormattedMessage id="label.realizadoPeriodoAnterior" />;
    case 'DesempenhoPeriodoAnterior':
      return capitalizeFirstLetter(
        intl.formatMessage(
          { id: 'label.desempenhoPeriodoAnterior' },
          { desempenho: resources.desempenho }
        )
      );
    case 'MetaAcumuladoPeriodoAnterior':
      return capitalizeFirstLetter(
        intl.formatMessage(
          { id: 'label.metaAcumuladoPeriodoAnterior' },
          { metaacumulado: resources.metaacumulado }
        )
      );
    case 'RealizadoAcumuladoPeriodoAnterior':
      return <FormattedMessage id="label.realizadoAcumuladoPeriodoAnterior" />;
    case 'DesempenhoAcumuladoPeriodoAnterior':
      return capitalizeFirstLetter(
        intl.formatMessage(
          { id: 'label.desempenhoAcumuladoPeriodoAnterior' },
          { desempenho: resources.desempenho }
        )
      );
    case 'Score':
      return <FormattedMessage id="score" />;
    case 'ScoreCategoria':
      return <FormattedMessage id="scoreCategoria" />;
    case 'PontosPorFaixaTransformada':
      return <FormattedMessage id="label.pontosPorFaixaTransformada" />;
    case 'ScoreHierarquiaArea':
      return capitalizeFirstLetter(
        intl.formatMessage(
          { id: 'label.scoreHierarquiaArea' },
          { area: resources.area }
        )
      );
    case 'ScoreHierarquiaColaborador':
      return capitalizeFirstLetter(
        intl.formatMessage(
          { id: 'label.scoreHierarquiaColaborador' },
          { colaborador: resources.colaborador }
        )
      );
    case 'DesempenhoEstimado':
      return capitalizeFirstLetter(
        intl.formatMessage(
          { id: 'desempenhoEstimado' },
          {
            desempenhoforecast: resources.desempenhoforecast,
          }
        )
      );
    case 'DesempenhoEstimadoAcumulado':
      return capitalizeFirstLetter(
        intl.formatMessage(
          { id: 'desempenhoEstimadoAcumulado' },
          {
            desempenhoforecastacumulado: resources.desempenhoforecastacumulado,
          }
        )
      );
    case 'MetaAnoAnterior':
      return capitalizeFirstLetter(
        intl.formatMessage({ id: 'metaAnoAnterior' }, { meta: resources.meta })
      );
    case 'RealizadoAnoAnterior':
      return capitalizeFirstLetter(
        intl.formatMessage(
          { id: 'realizadoAnoAnterior' },
          { realizadoanoanterior: resources.realizadoanoanterior }
        )
      );
    case 'MetaAcumuladoAnoAnterior':
      return capitalizeFirstLetter(
        intl.formatMessage(
          { id: 'metaAcumuladaAnoAnterior' },
          { meta: resources.meta }
        )
      );
    case 'RealizadoAcumuladoAnoAnterior':
      return capitalizeFirstLetter(
        intl.formatMessage(
          { id: 'realizadoAcumuladoAnoAnterior' },
          { realizadoacumanoanterior: resources.realizadoacumanoanterior }
        )
      );
    case 'PontosPorFaixaRealizado':
      return <FormattedMessage id="label.pontosPorFaixaRealizado" />;
    case 'PontosPorFaixaRealizadoAcumulado':
      return <FormattedMessage id="label.pontosPorFaixaRealizadoAcumulado" />;
    case 'notaMetaIndividual':
      return capitalizeFirstLetter(
        intl.formatMessage(
          { id: 'notaMetaIndividual' },
          { metaindividual: resources.metaindividual }
        )
      );
    case 'Valor':
      return <FormattedMessage id="valor" />;

    case 'Estimado':
      return capitalizeFirstLetter(
        intl.formatMessage(
          { id: 'valorEstimado' },
          { valorestimado: resources.valorestimado }
        )
      );

    case 'EstimadoAcumulado':
      return capitalizeFirstLetter(
        intl.formatMessage(
          { id: 'estimadoAcumulado' },
          { valorestimado: resources.valorestimado }
        )
      );
    default:
      return termo;
  }
}
